<script>
export default {
  name: 'PageHeaderSearchForm',

  props: {
    searchUrl: String,
    searchInputLabel: String,
    searchButtonLabel: String,
  },
}
</script>

<template>
  <form
    class="page-header-search-form"
    :action="searchUrl"
  >
    <div class="page-header-search-form__container container">
      <label
        class="page-header-search-form__label"
        for="page-header-search-input"
      >
        {{ searchInputLabel }}
      </label>
      <input
        id="page-header-search-input"
        type="search"
        name="q"
        class="page-header-search-form__input form-control"
      >
      <button
        class="page-header-search-form__button"
        type="submit"
        :aria-label="searchButtonLabel"
      >
        <i class="far fa-fw fa-search"></i>
      </button>
    </div>
  </form>
</template>
